import { Box, Button, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenGrid from '../../../../../../global_components/KenGrid';
import KenInputField from '../../../../../../global_components/KenInputField';
import {
  getCreateGradeRange,
  postDefualtGradeSetup,
} from '../../../../../../Utils/apiServices';
// import { LineChart } from './LineChart';
//  Add the Colum name

const columnGrad = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'Grade Point',
    accessor: 'cgpa',
    disableGlobalFilter: true,
  },

  {
    Header: 'Percentile Range',
    accessor: 'percentile',
    disableGlobalFilter: true,
  },
  {
    Header: 'Mark Range',
    accessor: 'markRange',
    disableGlobalFilter: true,
  },

  {
    Header: 'Letter Grade ',
    accessor: 'grade_name',
    disableGlobalFilter: true,
    // Cell: QuestionPaperCell,
  },
];

const DefaultGradingRelative = () => {
  const [objSlider, setObjSlider] = useState();

  const [columnGridAbsolute, setColumnGridAbsolute] = useState(columnGrad);

  const cgpaCell = (rows, i) => {
    return (
      <Box>
        <Grid item xs={12} sm={3}>
          <KenInputField
            name={rows}
            optionalLabel={false}
            value={rows}
            dropdownColor="#ffffff"
            // onChange={(e) => handleChangeCgpa(e, rows, i)}
            style={{ fontSize: 12 }}
          />
        </Grid>
      </Box>
    );
  };
  const handleChangeSlider = (e, index) => {
    let valueSlider = e.target.value.split('-');
    const arrData = valueSlider.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (true) {
      setObjSlider((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return { ...single, value: [arrData[0] || 0, arrData[1] || 0] };
          } else {
            return single;
          }
        });
      });
    }
  };

  const handleChangeSliderForMarksRange = (e, index) => {
    let marksRange = e.target.value.split('-');
    const arrData = marksRange.map((ele) => parseInt(ele));
    if (!Array.isArray(arrData)) {
      return;
    }
    if (true) {
      setObjSlider((prevState) => {
        return prevState.map((single, i) => {
          if (i === index) {
            return {
              ...single,
              marksRange: [arrData[0] || 0, arrData[1] || 0],
            };
          } else {
            return single;
          }
        });
      });
    }
  };

  const dataGrad = objSlider?.map((ele, i) => {
    return {
      id: i + 1,
      percentile: (
        <Grid item xs={12} sm={8}>
          <KenInputField
            optionalLabel={false}
            value={ele.value.join(' - ')}
            onChange={(e, value) => handleChangeSlider(e, i, value, 0)}
            // onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      markRange: (
        <Grid item xs={12} sm={8}>
          <KenInputField
            optionalLabel={false}
            value={ele.marksRange.join(' - ')}
            onChange={(e, value) =>
              handleChangeSliderForMarksRange(e, i, value, 0)
            }
            // onBlur={() => handleOnBlur()}
            style={{ fontSize: 12 }}
          />
        </Grid>
      ),
      cgpa: cgpaCell(ele.cgpa, i),
      grade_name: cgpaCell(ele.grade, i),
    };
  });
  const [dataGridAbsolute, setDataGradAbsolute] = useState(dataGrad);
  const postData = () => {
    const data = objSlider?.map((item) => {
      return {
        recordId: item.id,
        typeOfGrading: 'Relative',
        letterGrade: item.grade,
        upperPercentageLimit: item.marksRange[0],
        lowerPercentageLimit: item.marksRange[1],
        upperPercentileLimit: item.value[0],
        lowerPercentileLimit: item.value[1],
      };
    });

    postDefualtGradeSetup(data)
      .then((res) => {
        DefaultGrade();
        console.log('getGradingCourseDetails', res);
      })
      .catch((err) => {
        console.log('Grading Course Details error', err);
      });
  };

  const DefaultGrade = () => {
    getCreateGradeRange().then((res) => {
      console.log('resresresresresresresres', res);
      const finalData =
        res == null
          ? []
          : res[1]?.gradeRangeWrapper?.map((item, index) => {
              console.log('itemitemitemitemitemitem-----', item);
              // const myArray = item.markRange.split('-');
              const myArray = [item.maxPercentile, item.minPercentile];

              const MarksRangeArray = [item.maximumMark, item.minimumMark];

              console.log('myArraymyArraymyArray', myArray);
              return {
                id: item.id,
                value: myArray,
                marksRange: MarksRangeArray,
                cgpa: item.gradePoint,
                grade: item.letterGrade,
              };
            });
      setObjSlider(finalData);
    });
  };

  useEffect(() => {
    DefaultGrade();
  }, []);
  useEffect(() => {
    // setObjSlider(pre => pre)
    setDataGradAbsolute(dataGrad);
  }, [objSlider]);

  return (
    <div>
      <Box>
        {' '}
        <div>
          {' '}
          <div style={{ textTransform: 'uppercase', textAlign: 'center' }}>
            <b>Default Grading : Relative </b>
          </div>{' '}
          <hr />
          <Grid container>
            {/* <Grid xs={5}>
              <LineChart />
            </Grid> */}
            <Grid xs={12}>
              <KenGrid
                columns={columnGridAbsolute}
                data={dataGrad}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
                initialState={{
                  hiddenColumns: ['id'],
                }}
              />
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '15px' }}
                // className={classes.addButton}
                onClick={() => {
                  postData();
                }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default DefaultGradingRelative;
